import { EventPanelFormType } from '@mark43/cad-api';
import { entityContainsValidKeys } from '../../panels/entity-panels/forms/entity-filtering';

/**
 * Validates if a vehicle has any meaningful identification or description data.
 * A vehicle is considered valid if it has ANY of the following:
 * - VIN number
 * - License plate number
 * - Make (standard or custom)
 * - Model (standard or custom)
 * - Color
 * - Year
 * - Notes/Description
 *
 * This ensures that partial vehicle information (e.g., make/model without plate)
 * is preserved and saved to the database.
 */
export function isValidVehicle(vehicle: EventPanelFormType['vehicles'][number]): boolean {
    return !!(
        vehicle.vinNumber?.trim() ||
        vehicle.plateNumber?.trim() ||
        vehicle.vehicleMakeOther?.trim() ||
        vehicle.vehicleModelOther?.trim() ||
        vehicle.notes?.trim() ||
        vehicle.autoInsuranceCarrier?.trim() ||
        vehicle.year ||
        vehicle.colorOption ||
        vehicle.stateOption ||
        vehicle.vehicleMakeOption ||
        vehicle.vehicleModelOption ||
        vehicle.involvementTypeOption
    );
}

export function filterInvalidEventPanelEntities(
    eventPanelForm: EventPanelFormType
): EventPanelFormType {
    return {
        ...eventPanelForm,
        vehicles: eventPanelForm.vehicles.filter(isValidVehicle),
        reportingParties: eventPanelForm.reportingParties.filter((person) =>
            entityContainsValidKeys(person, [
                'firstName',
                'lastName',
                'phoneNumber',
                'phoneExtension',
                'location',
                'locationSubPremise',
                'notes',
            ])
        ),
    };
}
